export default {
  name: "faqSection",
  methods: {
    directionClass() {
      if (this.$store.state.locale == 'ar') return 'directionRight'
      else return 'directionLeft'
    }
  }
};
